import React from 'react';
import { ConfirmPopup } from './../../../common/popup';
import { connect } from 'react-redux';
import { REDUCER_NAME, toggleConfirmPopupCreateWatchList } from './../reducer';

class ConfirmCreatePopup extends React.Component {
  render() {
    const { isShow, confirm, title, messages } = this.props;

    return (
      <ConfirmPopup
        isShow={isShow}
        messages={messages}
        title={title}
        confirm={confirm}
        enabledApply={false}
        enabledCancel={false}
        iconName={'icon-warning'}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    isShow: state[REDUCER_NAME].createWl.isShowPopup,
    title: state[REDUCER_NAME].createWl.title,
    messages: state[REDUCER_NAME].createWl.messages,
  };
};

const mapDispatchToProps = {
  confirm: toggleConfirmPopupCreateWatchList,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ConfirmCreatePopup);
